export default function NewProjInfo(){
  return(
    <div>
      New Project Info coming soon!
    </div>
  );
}